import type { FirestoreQuery } from '@shared/types';
import { generateQueryPreviewCode } from './query-preview.domain';

export interface QueryPreviewProps {
  query: FirestoreQuery;
  collectionName: string;
  hideHeading?: boolean;
}

export function useQueryPreview({ query, collectionName }: QueryPreviewProps) {
  const code = generateQueryPreviewCode(query, collectionName);
  return { code };
}
